import { GridCellProps } from '@progress/kendo-react-grid';
import { TextBoxChangeEvent } from '@progress/kendo-react-inputs';
import { FC, useCallback } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import TextInput from 'src/components/TextInput';
import { useContextSelector } from 'use-context-selector';
import { InvoiceContext } from '../InvoiceDetailsContext';

const TextField: FC<GridCellProps> = (props: GridCellProps) => {
  const { dataItem, field = '', onChange, dataIndex } = props;
  const isInvoiceEditDisabled = useContextSelector(
    InvoiceContext,
    (value) => value.isInvoiceEditDisabled
  );
  const value = dataItem[field];

  const handleChange = useCallback(
    (e: TextBoxChangeEvent) => {
      onChange?.({
        dataIndex: dataIndex,
        dataItem: dataItem,
        field: field,
        syntheticEvent: e.syntheticEvent,
        value: e.target.value,
      });
    },
    [dataIndex, dataItem, field, onChange]
  );

  return (
    <GridCellBase {...props}>
      {isInvoiceEditDisabled || dataItem.poQty !== 0 ? (
        <p className="text-center">{value}</p>
      ) : (
        <TextInput type={'text'} value={value} valid={!!value} onChange={handleChange} />
      )}
    </GridCellBase>
  );
};

export default TextField;
